module.exports = __webpack_public_path__ + "img/Tabelle.c966895c.png";